import React from 'react';

const foodItems = [
  {
    id: 'food-bbq',
    emoji: '🍔',
    title: 'BBQ & Refreshments',
    desc: 'Hot food, cold drinks, burgers, hot dogs and snacks available all day. Run by New Milton RFC volunteers.',
    hours: 'All Day',
    type: 'Club Bar & BBQ',
  },
  {
    id: 'food-vendors',
    emoji: '🍕',
    title: 'Local Food Vendors',
    desc: 'A selection of local food businesses serving a variety of cuisines. From street food to hot snacks.',
    hours: '11:00 AM – 4:00 PM',
    type: 'Food Court',
  },
  {
    id: 'food-sweet',
    emoji: '🍭',
    title: 'Sweet Treats',
    desc: 'Candy floss, toffee apples, chocolate treats and all the classic fairground sweet favourites.',
    hours: 'All Day',
    type: 'Sweet Stall',
  },
  {
    id: 'food-ice',
    emoji: '🍦',
    title: 'Ice Cream',
    desc: "Soft serve and traditional ice cream. Perfect for a sunny day out! The kids\' favourite.",
    hours: 'All Day',
    type: 'Ice Cream Van',
  },
];

export default function FoodCards() {
  return (
    <div className="space-y-4">
      <h2 className="text-lg font-bold text-foreground">Food & Refreshments</h2>
      {foodItems?.map((food) => (
        <div key={food?.id} className="bg-card rounded-2xl overflow-hidden card-shadow border border-border">
          <div className="img-placeholder h-32 flex items-center justify-center">
            <div className="text-center">
              <span className="text-5xl block mb-1">{food?.emoji}</span>
              <p className="text-muted-foreground/60 text-xs">Photo coming soon</p>
            </div>
          </div>
          <div className="p-4">
            <div className="flex items-start justify-between gap-2 mb-2">
              <h3 className="font-bold text-base text-foreground">{food?.title}</h3>
              <span className="text-[10px] font-bold px-2 py-1 rounded-full bg-accent/10 text-accent flex-shrink-0">
                {food?.type}
              </span>
            </div>
            <p className="text-sm text-muted-foreground leading-relaxed mb-3">{food?.desc}</p>
            <div className="flex items-center gap-1.5">
              <span className="text-xs">🕐</span>
              <span className="text-xs font-semibold text-foreground">{food?.hours}</span>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
}